export default __webpack_public_path__ + "static/sm-poster4-457a9f74f6dade74c2164a077792d5a1.png";